// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".po-user .--admin-only{display:none}.admin-user .--admin-only,.po-user .--po-only{display:block}.admin-user .--po-only{display:none}.rounded-8px{border-radius:8px!important}", ""]);
// Exports
module.exports = exports;
